import React, { useState } from 'react';
import '../styles/index.css';
import { MDBFooter, MDBTypography, MDBRow, MDBCol, MDBContainer, MDBIcon, MDBNavbarBrand } from 'mdb-react-ui-kit';
import Logo from "../images/Logo-v2-cropped.png"
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
    const { language } = useLanguage();

    return (
        <MDBFooter breakpoint="lg" style={{ backgroundColor: "#f5f1f182"}} id='contact-container' className='text-center container-fluid p-0'>

            <MDBContainer>
                {/* Operating across the EU and Moldova */}
                <MDBRow data-aos="fade-up" data-aos-duration='700' data-aos-delay="200" className='justify-content-center'>
                    <MDBCol md='12' className='py-4'>
                        <MDBTypography tag='h3' className='text-start mb-4' style={{ color: '#50b9df', fontWeight: 600}}>
                            {language === 'EN' 
                                ? 'Operating across the European Union and Moldova' 
                                : 'Operăm în întreaga Uniune Europeană și Moldova'}
                        </MDBTypography>

                        {/* Phone Numbers */}
                        <div className='d-flex align-items-center mb-3'>
                            <MDBIcon fas icon='mobile-alt' size='xl' className='me-3 mt-1' style={{ color: '#50b9df', fontSize: "2.5rem", width: "4rem" }} />
                            <div className='contact-text'>
                                <MDBTypography tag='p' className='mb-1 lead' >
                                    Moldova <a style={{color: "#4f4f4f", textDecoration: "none", fontWeight: "500"}} href="tel:+37369123456">+373 79 512 300</a>
                                </MDBTypography>
                                <MDBTypography tag='p' className='mb-0 lead'>
                                    {language === 'EN' ? 'EU Countries' : 'Țări UE'} <a style={{color: "#4f4f4f", textDecoration: "none", fontWeight: "500"}} href="tel:+4069123456">+40 746 082 572</a>
                                </MDBTypography>
                            </div>
                        </div>

                        {/* Email */}
                        <div className='d-flex align-items-center mb-2'>
                            <MDBIcon far icon='envelope' className='me-3' style={{ color: '#50b9df', fontSize: "2.5rem", width: "4rem" }} />
                            <MDBTypography tag='p' className='mb-0 lead'>
                                <a style={{color: "#4f4f4f", textDecoration: "none"}} href="mailto:scrieunemail@gmail.com">acicanci@gmail.com</a>
                            </MDBTypography>
                        </div>
                    </MDBCol>
                </MDBRow>

                {/* Divider */}
                <hr className='border-secondary' style={{ borderColor: 'rgba(255,255,255,0.25)', margin: "0" }} />

                {/* Copyright + Logo Row */}
                <MDBRow className='align-items-center justify-content-between py-2'>
                    <MDBCol className='text-start'>
                        <MDBTypography tag='p' id='copyright-text' className='mb-0'>
                            © 2026 Solexpres, SRL.
                        </MDBTypography>
                    </MDBCol>

                    <MDBCol className='d-flex align-items-center justify-content-end gap-2'>
                        <img
                            src={Logo}
                            height='45'
                            alt='Solexpres logo'
                            loading='lazy'
                            style={{ objectFit: 'contain' }}
                        />
                        <MDBTypography tag='span' className='mb-0' style={{ fontSize: '1.4rem', fontWeight: 600, letterSpacing: '0.08em', color: '#384159' }}>
                            SOLEXPRES
                        </MDBTypography>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>

        </MDBFooter>
    );
}